import UtilsObject from "@/utilities/UtilsObject";

export function isNotEmptyArray(array) {
  for (let item of array) {
    if (item !== "") {
      return true;
    }
  }
  return false;
}

export function isNotEmpty2dArray(array) {
  if (array != undefined) {
    for (let subArray of array) {
      if (isNotEmptyArray(subArray)) {
        return true;
      }
    }
  }
  return false;
}

export function createEmpty2dArray(length) {
  var matrix = [];
  for (var i = 0; i < length; i++) {
    matrix[i] = [];
  }
  return matrix;
}

export function stringToArray(str) {
  let arr = [];
  for (let item of str.toString().split(",")) {
    arr.push(item.trim());
  }
  return arr;
}

export function isNumericArrayValid(arr) {
  let valid = arr.length > 0;
  if (valid) {
    for (let item of arr) {
      if (isNaN(item) || item === "") {
        return false;
      }
    }
  }
  return valid;
}

export function convertToPctArray(str, shouldPrependZero = true) {
  let arr = [];
  if (shouldPrependZero) {
    arr.push(0);
  }
  if (str) {
    for (let item of str.toString().split(",")) {
      arr.push(item.trim() / 100);
    }
  }
  return arr;
}

export function sortArray(arr, ascending = true, field = null) {
  return arr.sort(function (a, b) {
    let el1 = field ? UtilsObject.getByPath(a, field) : a;
    let el2 = field ? UtilsObject.getByPath(b, field) : b;
    el1     = String(el1);
    el2     = String(el2);
    if (el1.toLowerCase) el1 = el1.toLowerCase();
    if (el2.toLowerCase) el2 = el2.toLowerCase()
    const res = ascending
      ? el1.localeCompare(el2, undefined, {numeric: true, sensitivity: 'base'})
      : -1 * el1.localeCompare(el2, undefined, {numeric: true, sensitivity: 'base'});
    return res;
  });
}

export function arrayElIsFirst(arr, i) {
  return i === 0;
}

export function arrayElIsLast(arr, i) {
  return arr.length - 1 === i;
}

// ##################################################
// region Vue-Sensitive Array MManipulations
/**
 * Vue observes JS-Objects (Objects, Arrays, etc.)
 * If you re-assign some their properties or even themselves, Vue looses control!!!
 * See "Reactivity in depth" article:
 * @link https://vuejs.org/v2/guide/reactivity.html
 * See "Array Change Detection" article:
 * @link https://vuejs.org/v2/guide/list.html#Array-Change-Detection
 * So set of functions below are intended to improve developments progress.
 * */
export function arrayElsSwap(arr, i1, i2) {
  /**
   * In order to make framework react on Array changes,
   * it is used more complicated way to change order of properties.
   * @see https://vuejs.org/v2/guide/list.html#Caveats
   */
  arr[i1] = arr.splice(i2, 1, arr[i1])[0];
  return arr;
}

export function arrayElSetEarlier(arr, i) {
  if (arrayElIsFirst(arr, i)) {
    return arr;
  }
  arrayElsSwap(arr, i, i - 1);
  return arr;
}

export function arrayElSetLater(arr, i) {
  if (arrayElIsLast(arr, i)) {
    return arr;
  }
  arrayElsSwap(arr, i, i + 1);
  return arr;
}

export function arrayElInsertAt(arr, el, position = 0) {
  return arr.splice(position, 0, el);
}

export function arrayElRemoveByIndex(arr, i) {
  return arr.splice(i, 1);
}

export function arrayElRemoveByValue(arr, v) {
  if (arr.includes(v)) {
    const i = arr.indexOf(v);
    arrayElRemoveByIndex(arr, i);
  }
  return arr;
}

export function arrayClear(arr) {
  return arr.splice(0, arr.length);
}

/**
 * Why: https://vuejs.org/v2/guide/list.html
 * Approach: https://stackoverflow.com/a/1348196/3142281
 * In short: Vue does not react on .concat() function
 * */
export function arrayVueSensitiveConcat(arr1, arr2) {
  // return [].splice.apply(arr1, [arr1.length+1, 0].concat(arr2));
  return arr1.splice(arr1.length + 1, 0, ...arr2);
}

export function arrayElPushIfNotAlready(arr, val) {
  if (!arr.includes(val)) {
    arr.push(val);
  }
  return arr;
}

// endregion Vue-Sensitive Array MManipulations
// ##################################################
